/**
 * Bandeau permanent affiché quand l'utilisateur explore l'org d'exemple isolée.
 * Rappelle que les données sont fictives et offre le retour à son espace vide
 * ("Repartir de zéro" → supprime l'org démo côté serveur). Cf. plan onboarding Conv 4.
 */

import { type ReactNode } from 'react';
import { FlaskConical, RotateCcw } from 'lucide-react';
import { useOnboardingStatus, useDemoToggle } from '@/hooks/useOnboarding';

export function DemoBanner(): ReactNode {
    const { data: status } = useOnboardingStatus();
    const { reset } = useDemoToggle();

    if (!status?.demoMode) return null;

    return (
        <div className="bg-[#EFF6FF] dark:bg-[#1E3A5F] border-b border-[#BFDBFE] dark:border-[#3B82F6]/40">
            <div className="flex items-center gap-3 px-4 lg:px-6 py-2.5">
                <FlaskConical className="h-4 w-4 shrink-0 text-[#1D4ED8] dark:text-[#60A5FA]" />
                <p className="flex-1 min-w-0 text-sm text-[#1E3A5F] dark:text-[#DBEAFE]">
                    <span className="font-semibold">Mode exemple</span>
                    <span className="hidden sm:inline"> : vous explorez un chantier fictif pour découvrir BTPal. Rien n'est enregistré dans votre espace.</span>
                </p>
                <button
                    type="button"
                    onClick={() => reset.mutate()}
                    disabled={reset.isPending}
                    className="shrink-0 inline-flex items-center gap-1.5 h-9 px-3 rounded-md text-sm font-medium text-white bg-[#1D4ED8] hover:bg-[#1E40AF] dark:bg-[#2563EB] dark:hover:bg-[#1D4ED8] transition-colors disabled:opacity-60"
                >
                    <RotateCcw className="h-3.5 w-3.5" />
                    {reset.isPending ? 'Retour...' : 'Repartir de zéro'}
                </button>
            </div>
        </div>
    );
}

export default DemoBanner;
